module.exports = {
  realm: 'NL',
  market: 'nl-NL',
  domain: 'weightwatchers.nl',
  countryId: '24000',
  vsPath: 'nl',
  spiceLocale: 'nl',
  vsUrl: 'https://www{env}weightwatchers.com/nl',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/nl/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.nl/',
  currency: '€',
  decimalSeparator: ',',
  thousandSeparator: '.',
  currencyFormat: '€ %number',
  dateFormat: 'dd-MM-yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.nl/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.nl/v2/login/',
  countryCode: 'NL',
  commUlr: 'https://commerce{env}weightwatchers.com/nl/nl/api/',
  timezone1: 'Europe/Amsterdam',
  timezone2: '+01:00',
};
